import React, { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

const AuthCallback = () => {
  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        console.log('AuthCallback: Processing OAuth redirect...');
        
        // Use PKCE flow - exchange the full URL for session
        const { data, error } = await supabase.auth.exchangeCodeForSession(window.location.href);
        
        if (error) {
          console.error('AuthCallback: Session exchange failed:', error);
          throw error;
        }

        console.log('AuthCallback: Session exchange successful');
        
        // Verify session is established
        const { data: sessionData } = await supabase.auth.getSession();
        if (!sessionData.session) {
          throw new Error('Session not established after code exchange');
        }

        console.log('AuthCallback: Session confirmed, redirecting to dashboard');
        
        // Hard redirect to dashboard - this forces full app reload with fresh session
        window.location.replace('/dashboard');
        
      } catch (error: any) {
        console.error('AuthCallback: Authentication failed:', error);
        
        // Show minimal error and redirect to home
        const errorMsg = error?.message || 'Authentication failed';
        console.error('OAuth Error:', errorMsg);
        
        // Hard redirect to home on error
        window.location.replace('/');
      }
    };

    handleAuthCallback();
  }, []);

  // Show minimal loading indicator during auth processing
  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center space-y-4">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto"></div>
        <p className="text-muted-foreground">Completing sign-in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;